import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['jumpButton'];

    connect() {
        // On each controller mount we want to collect all potentially focusable DOM
        // elements based on section style class name. In case of no focusable element,
        // we should hide the jump/skip button
        this.focusCandidates = [];
        const targetClassName = `.${this.targetSectionClass}`;
        const targets = document.querySelectorAll(targetClassName);
        // No focusable target section - DOM element with reference style class name
        if (!targets.length) {
            this.hideJumpButton();
            return;
        }
        // For each focusable target section, collect all focusable child elements
        targets.forEach((targetBlockElement) => {
            targetBlockElement.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])').forEach((candidateElement) => {
                const elementStyle = window.getComputedStyle(candidateElement);
                // Screen reader can't reach element if it's hidden using the css
                const display = elementStyle.getPropertyValue('display');
                if (display === 'none') return;
                const visibility = elementStyle.getPropertyValue('visibility');
                if (visibility === 'hidden') return;
                this.focusCandidates.push(candidateElement);
            })
        });
        // In case of no focusable elements hide the jump button
        if (!this.focusCandidates.length) {
            this.hideJumpButton();
            return;
        }
    }

    hideJumpButton() {
        if (this.hasJumpButtonTarget) {
            this.jumpButtonTarget.classList.add('hidden');
        }
    }

    get targetSectionClass() {
        return this.data.get("targetClass");
    }

    skip2section(e) {
        // To enable keyboard triggering using enter and space key only
        if (!this.focusCandidates.length) return;
        if (e.keyCode && !(e.keyCode === 13 || e.keyCode === 32)) return
        e.preventDefault();
        // Jump the focus to the first element from the pre-made list
        this.focusCandidates[0].focus();
    }
}
